<script lang="ts">
  import { Search, Plus } from 'lucide-svelte';

  let {
    value = $bindable(''),
    placeholder = 'Search...',
    onCreate,
    createLabel = 'New'
  }: { value: string; onCreate?: () => void; createLabel?: string; placeholder?: string } = $props();
</script>

<div class="mb-4 flex items-center gap-3">
  <!-- min-w-0 so a long createLabel ("New company", "New deal") can't squeeze
       the search field down to "Sea…" on a phone; below sm the create button
       drops its label and stays icon-only. -->
  <div class="relative min-w-0 max-w-sm flex-1">
    <Search class="pointer-events-none absolute left-2.5 top-2.5 h-4 w-4 text-dark-gray" />
    <input type="search" {placeholder} aria-label={placeholder} bind:value class="input" style="padding-left: 2rem" />
    <!-- inline padding: .input is unlayered CSS and its px-3 would beat a pl-8 utility -->
  </div>
  {#if onCreate}
    <button type="button" class="btn-primary shrink-0" onclick={onCreate} aria-label={createLabel}>
      <Plus class="h-4 w-4" />
      <span class="hidden whitespace-nowrap sm:inline">{createLabel}</span>
    </button>
  {/if}
</div>
